import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/contracts/copyContract/initialState.copycontract.data';
import { contractDetailsById as contractDetailsByIdAPI,
  priceAndServiceMapData as priceAndServiceMapDataAPI,
  getCopyContract as getCopyContractAPI } from '../../../../apis/contractsAPI';
import {ACTIONS_COPY_CONTRACT} from '../../../../constants/actionCreator';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';

export const fetchContractDetailsById = createAsyncThunkWrapper(
  ACTIONS_COPY_CONTRACT.FETCH_CONTRACT_DETAILS_BY_ID,
  contractDetailsByIdAPI 
);

export const fetchPriceAndServiceMap = createAsyncThunkWrapper(
  ACTIONS_COPY_CONTRACT.FETCH_PRICE_AND_SERVICE_MAP,
  priceAndServiceMapDataAPI 
);

export const fetchCopyContractData = createAsyncThunkWrapper(
  ACTIONS_COPY_CONTRACT.FETCH_COPY_CONTRACT_DATA,
  getCopyContractAPI
)

const CopyContractSlice = createSlice({
    name: 'copyContract',
    initialState,
    reducers: {
      setCopyContractNavigation:(state,action)=>{
        state.isDisplayCopyContractPage = action?.payload;
      },
      setSelectedValueForContract :(state,action)=>{
        state.contractSelectedValues = action?.payload;
      },
      setContractCopyRequestBody : (state,action)=>{
        state.contractCopyRequestBody = action?.payload;
      },
      setCopyContractResponse :(state,action)=>{
        state.copyContractResponse = action?.payload;
      }
    },
  
    extraReducers: (builder) => {
      builder
        .addCase(fetchContractDetailsById.pending, (state) => {
          state.contractDetails = [];
        })
        .addCase(fetchContractDetailsById.fulfilled, (state, action) => {
          state.contractDetails = action?.payload;
        })
        .addCase(fetchContractDetailsById.rejected, (state) => {
          state.contractDetails = [];
        })    
        .addCase(fetchPriceAndServiceMap.pending, (state) => {
          state.priceAndServiceMapData = [];
        })
        .addCase(fetchPriceAndServiceMap.fulfilled, (state, action) => {
          state.priceAndServiceMapData = action?.payload;
        })
        .addCase(fetchPriceAndServiceMap.rejected, (state) => {
          state.priceAndServiceMapData = [];
        })   
        .addCase(fetchCopyContractData.pending, (state) => {
          state.contractCopyRequestBody = [];
          state.copyContractResponse = null;
          state.loading = true;
        })
        .addCase(fetchCopyContractData.fulfilled, (state, action) => {
          state.contractCopyRequestBody = action?.payload;
          state.copyContractResponse = true;
          state.loading = false;
        })
        .addCase(fetchCopyContractData.rejected, (state) => {
          state.contractCopyRequestBody = [];
          state.copyContractResponse = false;
          state.loading = false;
        })    
    },
  });


  export const {setCopyContractNavigation,setSelectedValueForContract,setContractCopyRequestBody,setCopyContractResponse} = CopyContractSlice.actions;

  export default CopyContractSlice.reducer;